import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { IDocumentsTypes } from '../Interfaces/IDocumentsTypes';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';

@Injectable({
	providedIn: 'root',
})
export class DocumentsTypesService extends RestCallService {
	public dataToSend: IDocumentsTypes = {
		pkdocumenttype: 0,
		documenttype: '',
		description: '',
		fksite: 0,
		sitename: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 1,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 1,
		available: true,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
		fksiteloggeduser: 0,
		fkdocumentsupplier: 0,
		required_foreign_visit: false,
    str_required_foreign_visit: '',
    loaded: false
	};

	constructor(
		public httpClient: HttpClient,
    private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
	}

	public GetList() {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		var fksite = parseInt(localStorage.getItem('pksite'));
		return this.get<IDocumentsTypes[]>('/api/DocumentsTypes/GetDocumentsTypes?fksiteloggeduser=' + fksite);

		//return this.get<IDocumentsTypes[]>('/api/DocumentsTypes/GetDocumentsTypes?username=' + username + '&fksiteloggeduser=' + fksite);
	}

	public GetDocumentsTypesBySite() {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.fksiteloggeduser = parseInt(localStorage.getItem('pksite'));
		return this.post<IDocumentsTypes[]>('/api/DocumentsTypes/GetDocumentsTypesBySite', this.dataToSend);
	}

	public CreateDocumentType(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.documenttype = data.txtdocumenttype.trim();
		this.dataToSend.description = data.txtdescription.trim();
		this.dataToSend.fksite = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.fksiteloggeduser = parseInt(localStorage.getItem('pksite'));
		return this.post(
			'/api/DocumentsTypes/CreateDocumentType',
			this.dataToSend,
		);
	}

	public UpdateDocumentType(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
      		this.cognitoService.LogOut();
		this.dataToSend.pkdocumenttype = data.pkdocumenttype;
		this.dataToSend.documenttype = data.txtdocumenttype.trim();
		this.dataToSend.description = data.txtdescription;
		this.dataToSend.fksiteloggeduser = parseInt(localStorage.getItem('pksite'));
		return this.put(
			'/api/DocumentsTypes/UpdateDocumentType',
			this.dataToSend,
		);
	}
	
	public ChangeDocumentTypeStatus(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
     		this.cognitoService.LogOut();
		this.dataToSend.pkdocumenttype = data.pkdocumenttype;
		this.dataToSend.fksiteloggeduser = parseInt(localStorage.getItem('pksite'));
		this.dataToSend.available = data.available;
		return this.put('/api/DocumentsTypes/ChangeDocumentTypeStatus', this.dataToSend);
	}
}
